export abstract class Environment {
  production: boolean;
  apiUrl: string;
  apiVersion: string;
  rawApiUrl: string;
  config: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
  };

  requestFactFindEnabled: boolean;
  clientWebUrl: string;
  /** Tenant id resolved from the tenant route, used to look up TENANT_CONFIGS fallbacks. */
  tenantId?: string | null;
  /** Brand id resolved from the tenant route, used when neither the API nor TENANT_CONFIGS specifies a brand. */
  brandId?: string | null;
  swaggerApiLinks: {
    introducerApi: string;
  };
  websocketUrl: string;

  protected setup(environment: any) {
    for (const key in environment) {
      this[key] = environment[key];
    }
  }
}
